import React, { ReactNode } from 'react';
import './top-bar.scss';

interface ITopBarProps
{
    children: ReactNode;
}

const TopBar: React.FC<ITopBarProps> = ({ children }) =>
{
    return (
        <div className="top-bar">
            {children}
        </div>
    );
};

export default TopBar;
